import { autoserialize, autoserializeAs, inheritSerialization } from 'cerialize';

import { AbstractModel, DateUtil, isNullOrUndefined } from '@uzurv/core';
import { SigningTemplate } from './signing-template';

@inheritSerialization(AbstractModel)
export class SignatureRequest extends AbstractModel {
  @autoserialize
  driverId: number;

  @autoserialize
  signatureRequestId: string;

  @autoserialize
  signed: boolean;

  @autoserialize
  refused: boolean;

  @autoserialize
  refusalText: string;

  @autoserializeAs(Date)
  signedDate: Date;

  @autoserialize
  active: boolean;

  @autoserialize
  approved: boolean;

  @autoserialize
  rejected: boolean;

  @autoserialize
  rejectionComments: string;

  @autoserialize
  filename: string;

  @autoserialize
  reviewedByUserId: number;

  @autoserializeAs(SigningTemplate)
  signingTemplate: SigningTemplate;

  /**** Serialization ****/

  static OnSerialized(instance: SignatureRequest, json: any): void {
    super.OnSerialized(instance, json);

    if (!isNullOrUndefined(instance.signedDate)) {
      json.signedDate = DateUtil.serializeDate(instance.signedDate);
    }
  }

  static OnDeserialized(instance: SignatureRequest, json: any): void {
    super.OnDeserialized(instance, json);

    if (!isNullOrUndefined(json['signedDate'])) {
      instance.signedDate = DateUtil.deserializeDate(json['signedDate']);
    }
  }
}
